module.exports = __webpack_public_path__ + "exo-latin-400.3002b7531096a5092d6e.svg";


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/typeface-exo/files/exo-latin-400.svg
// module id = ../../../../typeface-exo/files/exo-latin-400.svg
// module chunks = styles